import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
  form: {
    display: 'flex',
    flexDirection: 'column',
    ...shorthands.gap('10px'),
  },
  field: {
    display: 'flex',
    flexDirection: 'column',
    ...shorthands.gap('4px'),
  },
  counter: {
    alignSelf: 'flex-end',
    color: tokens.colorNeutralForeground3,
    fontSize: '11px',
    lineHeight: '14px',
  },
  textarea: {
    minHeight: '84px',
  },
  previewActions: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
});